var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpdesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2289_7289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 20C4.27917 20 4.18333 19.9792 4.09583 19.9333C3.88333 19.8292 3.75 19.6125 3.75 19.375V16.25H1.875C1.375 16.25 0.904167 16.0542 0.55 15.7C0.195833 15.3458 0 14.875 0 14.375V1.875C0 1.375 0.195833 0.904167 0.55 0.55C0.904167 0.195833 1.375 0 1.875 0H18.125C18.625 0 19.0958 0.195833 19.45 0.55C19.8042 0.904167 20 1.375 20 1.875V14.375C20 14.875 19.8042 15.3458 19.45 15.7C19.0958 16.0542 18.625 16.25 18.125 16.25H9.58333L4.75 19.875C4.64167 19.9583 4.50833 20 4.375 20ZM1.875 1.25C1.70833 1.25 1.55 1.31667 1.43333 1.43333C1.31667 1.55 1.25 1.70833 1.25 1.875V14.375C1.25 14.5417 1.31667 14.7 1.43333 14.8167C1.55 14.9333 1.7125 15 1.875 15H4.375C4.72083 15 5 15.2792 5 15.625V18.125L9 15.125C9.10833 15.0458 9.24167 15 9.375 15H18.125C18.2917 15 18.45 14.9333 18.5667 14.8167C18.6833 14.7 18.75 14.5417 18.75 14.375V1.875C18.75 1.7125 18.6833 1.55 18.5667 1.43333C18.45 1.31667 18.2917 1.25 18.125 1.25H1.875Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.0625C9.48333 9.0625 9.0625 8.64167 9.0625 8.125C9.0625 7.60833 9.48333 7.1875 10 7.1875V9.0625Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.0625V7.1875C10.5167 7.1875 10.9375 7.60833 10.9375 8.125C10.9375 8.64167 10.5167 9.0625 10 9.0625Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.0625C5.73333 9.0625 5.3125 8.64167 5.3125 8.125C5.3125 7.60833 5.73333 7.1875 6.25 7.1875V9.0625Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.0625V7.1875C6.76667 7.1875 7.1875 7.60833 7.1875 8.125C7.1875 8.64167 6.76667 9.0625 6.25 9.0625Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.0625C13.2333 9.0625 12.8125 8.64167 12.8125 8.125C12.8125 7.60833 13.2333 7.1875 13.75 7.1875V9.0625Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.0625V7.1875C14.2667 7.1875 14.6875 7.60833 14.6875 8.125C14.6875 8.64167 14.2667 9.0625 13.75 9.0625Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2289_7289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpdesk);
export default __webpack_public_path__ + "static/media/helpdesk.8660436849b988915d83200eb46f1ae2.svg";
export { ForwardRef as ReactComponent };